module.exports = __webpack_public_path__ + "static/fra-f56df743fd009b1e0742241deab5b72c.png";